/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
  PdfExport,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Header from './Header';
import { ssteventsCPGrid } from '../data/dummy';
import '../pages/Zackat.css';

function SSTEvents({ props }) {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    zRenderMode,
    sstLimitPreference,
    setSSTLimitPreference,
  } = useStateContext();
  const [pauseEnable, setPause] = useState(false);
  const grid = useRef(null);
  const pause = { text: 'Pause', tooltipText: 'Pause Refresh', prefixIcon: 'e-pause', id: 'pause', disabled: pauseEnable };
  const resume = { text: 'Resume', tooltipText: 'Resume Refresh', prefixIcon: 'e-repeat', id: 'resume', disabled: !pauseEnable };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  let toolbarOptions = ['Search', pause, resume];
  const [searchParams] = useSearchParams();
  let associateid = searchParams.get('id');
  let assocId = searchParams.get('name');
  let associatename = 'SST Events for ';
  let device = searchParams.get('device');
  let myfont = '';
  let source = 'zackat-div';
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [sstEventLimit, setSSTEventLimit] = useState(localStorage.getItem('sstEventLimit') || 14);
  const limitTemplate = () => (
    <div className="e-toolbar-left">
      <input type="text" id="limit" placeholder="Limit number of days" defaultValue={sstEventLimit} className="custom-toolbar-input" />
      <button type="button" className="e-btn e-success e-outline" onClick={() => { const lim = document.getElementById('limit').value; setData([]); setSSTEventLimit(lim); localStorage.setItem('sstEventLimit', Number(lim), setSSTLimitPreference(!sstLimitPreference)); }}>Limit Days</button>
    </div>
  );

  if (props && props._id && props._id.length > 0 && props.name && props.name.length > 0) {
    associateid = props._id;
    assocId = props.name;
    device = props.device;
    associatename += props.name;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (props && props._id && props._id.length > 0 && props.device.length > 0) {
    associateid = ''; // props.associateid;
    assocId = props.device;
    device = props.device;
    associatename += props.device;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (associateid) {
    associatename += `${assocId}`;
  } else {
    associatename += `${device}`;
    associateid = null;
  }
  if (source === 'controlpanel') {
    toolbarOptions = ['Search', pause, resume, excel];
  }

  const editing = { allowDeleting: false, allowEditing: false };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const timerid = useRef();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (device !== null) {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        let url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&associateid=${associateid}&device=${device}&limit=${sstEventLimit}`;
        if (!associateid || associateid.length === 0) {
          url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&device=${device}&limit=${sstEventLimit}`;
        }
        await axios({
          url,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data) {
              setData(response.data);
            }
            setLoading(false);
          })
          .catch((error) => {
            console.error(error.message);
            setLoading(false);
          });
      } else {
        await axios({
          url: `${REACT_APP_API_ENDPOINT}/sst_events?associateid=${associateid}&limit=${sstEventLimit}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setData(response.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error.message);
            setLoading(false);
          });
      }
    };
    fetchData();
  }, [associateid, sstEventLimit]);

  async function fetchEvents() {
    const loc = window.location;
    if (loc.pathname !== '/sst_events' && !loc.pathname.includes('associate') && !loc.pathname.includes('/inventory') && !loc.pathname.includes('/basic')) {
      setPause(!pauseEnable);
      if (timerid.current) {
        timerid.current = clearInterval(timerid.current);
        return;
      }
    }
    if (device != null) {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');

      let url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&associateid=${associateid}&device=${device}&limit=${sstEventLimit}`;
      if (!associateid || associateid.length === 0) {
        url = `${REACT_APP_API_ENDPOINT}/sst_events?${query}&device=${device}&limit=${sstEventLimit}`;
      }
      await axios({
        url,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setData(response.data);
      })
        .catch((e) => {
          console.error(e);
        });
    } else {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/sst_events?associateid=${associateid}&limit=${sstEventLimit}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setData(response.data);
      })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  useEffect(() => {
    if (!pauseEnable) {
      timerid.current = setInterval(fetchEvents, 30000);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, [props, pauseEnable]);
  const flattenObject = (obj, prefix = '') => Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}.` : '';
    if (
      typeof obj[k] === 'object'
      && obj[k] !== null
      && Object.keys(obj[k]).length > 0
    ) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});

  const clickHandler = (args) => {
    if (args.item.properties.text === 'Pause') {
      setPause(!pauseEnable);
    } else if (args.item.properties.text === 'Resume') {
      setPause(!pauseEnable);
    } else if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_${associatename}_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(flattenObject(properties));
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_${associatename}_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(flattenObject(properties));
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const wrapSettings = { wrapMode: 'Both' };
  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div
      className={source === 'controlpanel' ? 'm-1 md:m-1 mt-2 p-2 md:p-2 rounded-3xl' : 'm-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div'}
    >
      <Header category="" title={associatename} />
      <div id="container">
        <ToolbarComponent id="toolbar">
          <ItemsDirective>
            <ItemDirective template={limitTemplate} disabled={false} />
            <ItemDirective type="Separator" />
          </ItemsDirective>
        </ToolbarComponent>
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data}
              className={myfont}
              allowPaging
              width="100%"
              allowSorting
              allowExcelExport
              allowPdfExport
              editSettings={editing}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              enableHover={false}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              allowFiltering
              filterSettings={FilterOptions}
              showColumnChooser
              allowTextWrap
              textWrapSettings={wrapSettings}
              ref={grid}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {ssteventsCPGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize, PdfExport, ExcelExport]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SSTEvents;
